import {
  ChakraBox,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

const { neutral } = EquipUIFireflyV2Theme.colors;
const { label, paragraphBold } = EquipUITheme.typography;

const EmptyDiagnosisList = () => (
  <ChakraBox
    alignItems="center"
    border={`3px dashed ${neutral.background.secondary}`}
    borderRadius="16px"
    id="patient__empty-diagnosis__section"
    justifyContent="center"
    padding="20px"
  >
    <ChakraText {...paragraphBold} color="neutral.secondary" textAlign="center">
      Primary diagnosis
    </ChakraText>
    <ChakraText {...label} color="neutral.secondary" textAlign="center">
      Select one primary diagnosis
    </ChakraText>
  </ChakraBox>
);

export default EmptyDiagnosisList;
